export function buildCourseDashboardPath(courseId: string): string {
  return `/studio/curso/${courseId}`;
}

export function buildCourseRubricPath(courseId: string, rubricId = 'nueva'): string {
  return `/studio/curso/${courseId}/rubrica/${rubricId}`;
}

export function buildCourseMaterialPath(
  courseId: string,
  materialPath: string,
): string {
  const [base, query = ''] = materialPath.split('?');
  const params = new URLSearchParams(query);
  params.set('course', courseId);
  return `${base}?${params.toString()}`;
}

export function buildPrintRubricPath(
  courseId: string,
  rubricId: string,
  autoPrint = false,
  roleId?: string,
): string {
  const base = `/studio/curso/${courseId}/rubrica/${rubricId}/imprimir`;
  const params = new URLSearchParams();
  if (autoPrint) params.set('auto', '1');
  if (roleId && roleId !== 'all') params.set('rol', roleId);
  const query = params.toString();
  return query ? `${base}?${query}` : base;
}
